// extracted by mini-css-extract-plugin
export default {"style":"lO0VU05e8L1QxacWeC9L"};